import {
  createStyles,
  TextField,
  type WithStyles,
  withStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import SelectDropdown from "components/SelectDropdown";
import React, { type ChangeEvent } from "react";
import type { CauseOfDeathFilterFormState } from "../causeOfDeath.types";
import { CauseOfDeathStatusFilter } from "../utils/causeOfDeath.utils";
import { useFilterOptions } from "../hooks/useFilterOptions";

type CauseOfDeathFilterFormProps = {
  filterForm: CauseOfDeathFilterFormState;
  onChangeFilter: <T extends keyof CauseOfDeathFilterFormState>(
    field: T,
    value: CauseOfDeathFilterFormState[T]
  ) => void;
} & WithStyles<typeof styles>;

function CauseOfDeathFilterForm({
  classes,
  filterForm,
  onChangeFilter,
}: CauseOfDeathFilterFormProps) {
  const { t } = useTranslations();
  const { statusOptions } = useFilterOptions();

  const handleChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
    onChangeFilter("searchText", event.target.value);
  };

  const handleChangeStatus = (value: CauseOfDeathStatusFilter) => {
    onChangeFilter("status", value);
  };

  return (
    <div className={classes.root}>
      <TextField
        autoFocus={true}
        className={classes.searchField}
        data-testid="search-filter-field"
        label={t("livestock:search-causes")}
        onChange={handleChangeSearch}
        value={filterForm.searchText}
      />

      <SelectDropdown
        className={classes.statusSelect}
        data-testid="status-select"
        label={{ text: t("livestock:cause-of-death-status") }}
        options={statusOptions}
        value={filterForm.status}
        onChange={handleChangeStatus}
      />
    </div>
  );
}

const styles = () =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      gap: "32px",
      paddingTop: "20px",
      width: "100%",
    },
    searchField: {
      width: "400px",
    },
    statusSelect: {
      maxWidth: 200,
      width: "100%",
    },
  });

export default withStyles(styles)(CauseOfDeathFilterForm);
